import { ActionButton, BaseTable, Loading, PermissionLink } from "components"
import { IoSendSharp } from "react-icons/io5"
import { approvalChecked, convertNumber, useApi } from "utils"
import { convertDate } from "pages/Inventori/Transaction/TransactionJournal/utils"
import { BillStatusResponse } from "../types"
import toast from "react-hot-toast"
import { ErrorFetch, SuccessFetch } from "types"
import { PERMISION } from "security"

export interface TableRegisterBillServiceProps {
  data: BillStatusResponse[]
  isLoading: boolean
  refetch: () => void
}

export const TableRegisterBillService = ({ data, isLoading, refetch }: TableRegisterBillServiceProps) => {
  const api = useApi()

  return (
    <div className="overflow-auto max-h-[calc(100vh-650px)]">
      <BaseTable className="border-transparent">
        <thead className="top-0 z-1 !bg-black !text-white">
          <tr className="uppercase">
            <th>No</th>
            <th>Bill Id#</th>
            <th>Date</th>
            <th>Vendor</th>
            <th>Approval</th>
            <th>Status</th>
            <th>Qty<br />Delivered</th>
            <th>Location</th>
            <th>Subtotal</th>
            <th>Payment</th>
            <th>Balance<br />Owing</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {!data.length || isLoading ? (
            <tr>
              <td colSpan={13} className="text-center">
                <Loading
                  loading={isLoading}
                  errorText={isLoading ? "" : "No data available"}
                />
              </td>
            </tr>
          ) : (
            data.map((val, index) => {
              const subTotal = Number(val?.total_tax_paid) + Number(val?.total) + Number(val?.freight)

              return (
                <tr>
                  <td>{index + 1}</td>
                  <td>{val?.trx_code ?? "-"}</td>
                  <td>{val?.transaction_date ? convertDate(val?.transaction_date) : "-"}</td>
                  <td>{val?.vendor_name ?? "-"}</td>
                  <td>{val?.approval_status ? approvalChecked(val?.approval_status) : "-"}</td>
                  <td>{val?.bill_status === 1 ? "OPEN" : "CLOSE"}</td>
                  <td className="text-center">{val?.quantity_unit ? convertNumber(parseFloat(val?.quantity_unit))?.intoNormalAmount : "-"}</td>
                  <td>{val?.location_name ?? "-"}</td>
                  <td className="text-right">{subTotal ? convertNumber(subTotal)?.intoCurrency : "0"}</td>
                  <td className="text-right">{val?.payment ? convertNumber(parseFloat(val?.payment))?.intoCurrency : "0"}</td>
                  <td className="text-right">{convertNumber(subTotal - parseFloat((val?.payment ?? 0)))?.intoCurrency}</td>
                  <td>
                    <section className="flex items-center gap-2">
                      <PermissionLink
                        permission={PERMISION.PURCHASES.REGISTER.BILLS_SERVICE.UPDATE}
                        to={`/purchase/transaction/bill-service/${val?.bill_id}`}
                        className="mt-1">
                        <IoSendSharp />
                      </PermissionLink>
                      {val?.approval_status === 1 && (
                        <ActionButton.Delete
                          permission={PERMISION.PURCHASES.REGISTER.BILLS_ITEM.DELETE}
                          className="text-error"
                          onClick={() => {
                            toast.promise(api.delete(`/probill/delete-bill-service/${val?.bill_id}`), {
                              loading: "Loading...",
                              success: (res: SuccessFetch<{ message: string }>) => res.data.message,
                              error: (err: ErrorFetch<{ message: string }>) => err.response.data.message
                            })
                              .then(() => {
                                // toggle()
                                refetch()
                              })
                              .catch(() => { })
                              .finally(() => refetch())
                          }}
                        />
                      )}
                    </section>
                  </td>
                </tr>
              )
            })
          )}
        </tbody>
      </BaseTable>
    </div>
  )
}
